import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import SlipVerifyDetail from '@/components/widgets/slip-verify/detail.vue'
import SlipVerifyAlert from '@/components/widgets/slip-verify/alert.vue'
import { loadSlipUrl } from '@/util/slip-image'

/**
 * รายงานงานโป๊ว (ระหว่างสาขา) Admin + ผจก.สาขา
 * มองจาก "สาขาที่เลือก": รับผลิตให้ = + (สาขาอื่นต้องจ่ายเรา) / ว่าจ้าง = − (เราต้องจ่าย)
 * backend จัดกลุ่มตามสาขาคู่ค้ามาให้แล้ว (groups[] → rows[])
 */
export default {
  components: {
    SlipVerifyAlert,
    DatePicker,
    SlipVerifyDetail,
  },
  data: function () {
    return {
      busy: false,
      role: '',
      userBranchId: '',
      apiStatus: 'กรุณาระบุเงื่อนไขและกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล',
      fields: [
        { key: 'index', label: '#', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'document_no', label: 'เลขที่เอกสาร', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'document_date', label: 'วันที่', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'side_text', label: 'ประเภท', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'status_text', label: 'สถานะ', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'creator_name', label: 'ผู้สร้าง', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2' },
        { key: 'item_count', label: 'รายการ', thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'total_length', label: 'ความยาว (ม.)', thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'total_steel_price', label: 'ค่าเหล็ก', thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'total_cut_price', label: 'ค่าตัด', thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'signed_amount', label: 'จำนวนเงิน', thClass: 'font-weight-bold text-xs-1/2 text-right', tdClass: 'text-xs-1/2 text-right' },
        { key: 'action', label: '', thClass: 'text-xs-1/2', tdClass: 'text-xs-1/2 text-center' },
      ],
      branches: [],
      groups: [],
      totals: null,
      reportBranch: null,
      // เคลียร์หนี้: modal อัปสลิปของคู่สาขาที่เลือก
      pay: { show: false, group: null, amount: '', file: null, remark: '', saving: false },
      // เดือน/สาขาของรายงานที่โหลดอยู่จริง (ตัวกรองอาจถูกเปลี่ยนแต่ยังไม่กดแสดงข้อมูล)
      loaded: { month: '', branchId: '' },
      filters: {
        month: new Date(moment().startOf('month').format('YYYY-MM-DD')),
        branch_id: '',
        counterparty_branch_id: '',
      },
    }
  },
  computed: {
    isAdmin() {
      return this.role === 'Admin'
    },
    branchOptions() {
      return [
        { value: '', text: '-- เลือกสาขา --' },
        ...this.branches.map((b) => ({ value: b.id, text: b.name })),
      ]
    },
    // สาขาคู่ค้า: ตัดสาขาหลักที่เลือกอยู่ออก (โป๊วให้ตัวเองไม่ได้)
    counterpartyOptions() {
      const self = Number(this.isAdmin ? this.filters.branch_id : this.userBranchId)
      return [
        { value: '', text: 'ทุกสาขา' },
        ...this.branches.filter((b) => Number(b.id) !== self).map((b) => ({ value: b.id, text: b.name })),
      ]
    },
    // moment ในโปรเจกต์นี้ไม่ได้ตั้ง locale th ใช้ชื่อเดือนไทยจาก mixin (lg.months) + ปี พ.ศ.
    monthLabel() {
      const m = moment(this.filters.month)
      const months = (this.lg && this.lg.months) || []
      return `${months[m.month()] || m.format('MMM')} ${m.year() + 543}`
    },
  },
  methods: {
    async getRole() {
      try {
        const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
        this.role = res?.data?.role || ''
        this.userBranchId = res?.data?.branch_id || ''
      } catch (e) {
        this.role = ''
        this.userBranchId = ''
      }
    },
    async loadBranches() {
      try {
        const res = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/branches`)
        const data = res?.data?.data || res?.data || []
        this.branches = Array.isArray(data) ? data : (data?.data || [])
      } catch (e) {
        this.branches = []
      }
    },
    formatNumber(value) {
      return parseFloat(value || 0).toLocaleString('th-TH', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    },
    buildQuery() {
      const params = new URLSearchParams()
      params.append('month', moment(this.filters.month).format('YYYY-MM'))
      // ผจก.สาขา: backend ล็อกสาขาตัวเองอยู่แล้ว ส่งไปก็ถูกทับ ส่งเฉพาะ Admin
      if (this.isAdmin && this.filters.branch_id) {
        params.append('branch_id', this.filters.branch_id)
      }
      if (this.filters.counterparty_branch_id) {
        params.append('counterparty_branch_id', this.filters.counterparty_branch_id)
      }
      return params
    },
    async onInitData() {
      if (this.isAdmin && !this.filters.branch_id) {
        return this.onExceptionHandler('กรุณาเลือกสาขา')
      }
      try {
        this.groups = []
        this.totals = null
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const res = await this.$axios.get(
          this.$host + '/api/v1/report/powngan?' + this.buildQuery().toString()
        )
        const data = res.data || {}
        this.groups = data.groups || []
        this.totals = data.totals || null
        this.reportBranch = data.branch || null
        this.loaded = { month: data.month || '', branchId: (data.branch && data.branch.id) || '' }

        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถค้นหาข้อมูลได้')
      }
    },
    // PDF แบบใบวางบิลระหว่างสาขา ไม่ส่ง counterparty = พิมพ์ทุกคู่ (1 หน้าต่อสาขาคู่ค้า + หน้าสรุป)
    async generatePDF(counterpartyBranchId) {
      if (this.isAdmin && !this.filters.branch_id) {
        return this.onExceptionHandler('กรุณาเลือกสาขา')
      }
      try {
        const params = this.buildQuery()
        if (counterpartyBranchId) {
          params.set('counterparty_branch_id', counterpartyBranchId)
        }
        const result = await this.$axios.get(
          `${Vue.prototype.$host}/api/v1/report/pdf/powngan?${params.toString()}`,
          { responseType: 'blob' }
        )
        const blob = new Blob([result.data], { type: 'application/pdf' })
        const objectUrl = URL.createObjectURL(blob)
        window.open(objectUrl, 'targetWindow', 'width=900,height=700')
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถสร้าง PDF ได้')
      }
    },
    openPayModal(group) {
      this.pay = {
        show: true,
        group,
        amount: group.settlement.we_owe,
        file: null,
        remark: '',
        saving: false,
      }
    },
    async submitPayment() {
      const amount = parseFloat(this.pay.amount)
      if (!(amount > 0)) return this.onExceptionHandler('กรุณาระบุยอดที่โอน')
      if (!this.pay.file) return this.onExceptionHandler('กรุณาเลือกไฟล์สลิป')
      const form = new FormData()
      // ใช้เดือน/สาขาของรายงานที่แสดงอยู่ ไม่ใช่ค่าในตัวกรอง
      form.append('month', this.loaded.month)
      form.append('counterparty_branch_id', this.pay.group.counterparty_branch_id)
      if (this.isAdmin) form.append('branch_id', this.loaded.branchId)
      form.append('amount', amount)
      form.append('remark', this.pay.remark || '')
      form.append('slip', this.pay.file)
      try {
        this.pay.saving = true
        const res = await this.$axios.post(`${this.$host}/api/v1/report/powngan/settlements`, form)
        this.pay.show = false
        const v = res.data && res.data.verify
        this.$swal({
          icon: v && v.level === 'ok' ? 'success' : 'warning',
          title: 'บันทึกการชำระแล้ว',
          text: v ? `ผลตรวจสลิป: ${v.label}${v.status !== 'passed' && v.message ? ': ' + v.message : ''}` : '',
        })
        await this.onInitData()
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'บันทึกไม่สำเร็จ')
      } finally {
        this.pay.saving = false
      }
    },
    async viewSettlementSlip(st) {
      const url = await loadSlipUrl(`${this.$host}/api/v1/report/powngan/settlements/${st.uuid}/slip`)
      if (!url) return this.onExceptionHandler('เปิดสลิปไม่ได้')
      window.open(url, '_blank')
    },
    async cancelSettlement(st) {
      const ok = await this.$swal({
        icon: 'warning',
        title: 'ยกเลิกรายการชำระนี้?',
        text: `${this.formatCurrency(st.amount)} บาท (ยอดค้างจะกลับมา)`,
        showCancelButton: true,
        confirmButtonText: 'ยกเลิกรายการ',
        cancelButtonText: 'ปิด',
      })
      if (!ok.isConfirmed && !ok.value) return
      try {
        await this.$axios.post(`${this.$host}/api/v1/report/powngan/settlements/${st.uuid}/cancel`)
        await this.onInitData()
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'ยกเลิกไม่สำเร็จ')
      }
    },
    openOrder(row) {
      const route = this.$router.resolve({ path: `/powngan/${row.uuid || row.id}` })
      window.open(route.href, '_blank')
    },
  },
  async mounted() {
    await this.getRole()
    // รายงานงานโป๊ว = Admin + ผจก.สาขาเท่านั้น (backend กันอีกชั้น) — role อื่นเข้าลิงก์ตรงให้พาออก
    if (!(this.role === 'Admin' || this.role === 'Branch Admin')) {
      this.onExceptionHandler('ไม่มีสิทธิ์ดูรายงานงานโป๊ว')
      this.$router.replace('/')
      return
    }
    // รายชื่อสาขาใช้ทั้งสอง role Admin เลือกสาขาหลัก, ทุกคนเลือกสาขาคู่ค้า
    await this.loadBranches()
    if (!this.isAdmin) {
      // ผจก.สาขาเห็นเฉพาะสาขาตัวเอง โหลดให้เลย
      this.filters.branch_id = this.userBranchId
      await this.onInitData()
    }
  },
}
